<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  data(){
    return{

    }
  },
  mounted() {
    if (this._isMobile()) {
      //移动端
      localStorage.setItem('isM',0)
    } else {
      //PC端
      localStorage.setItem('isM',1)
    }
    // this.resize();
    // window.addEventListener('resize',() => this.resize(), false)
  },
  methods:{
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    // resize() {
    //   var ratioX = $(window).width() / 1920;
    //   var ratioY = $(window).height() / 1080;
    //   localStorage.setItem("ratioX",ratioX)
    //   localStorage.setItem("ratioY",ratioY)
    //   $("#app").css({
    //     transform: "scale(" + ratioX + "," + ratioY + ")",
    //     transformOrigin:"left top",
    //     backgroundSize: "100% 100%",
    //     overflow: "hidden",
    //     width: "1920px",
    //     height: "1080px",
    //   });
    //   $("html").css({'overflow':'hidden'})
    // },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue